/**
 * Extract text content from a message
 * Handles string, array, and object content formats from LangGraph
 */
export function getContentString(content: string | any[] | any): string {
  // Already a string
  if (typeof content === 'string') {
    return content;
  }

  // Array of content blocks (LangChain format)
  if (Array.isArray(content)) {
    return content
      .filter((block: any) => block && (block.type === 'text' || block.type === undefined))
      .map((block: any) => {
        if (typeof block === 'string') return block;
        return block.text || block.content || String(block);
      })
      .filter((text: string) => text !== 'undefined' && text !== 'null')
      .join('');
  }

  // Object with text property
  if (content && typeof content === 'object') {
    if ('text' in content) return String(content.text);
    if ('content' in content) return String(content.content);
  }

  // Fallback: convert to string (will show [object Object] if all else fails)
  console.warn('⚠️ getContentString: Falling back to String(content)', {
    type: typeof content,
    isArray: Array.isArray(content),
    hasText: content && typeof content === 'object' && 'text' in content,
    hasContent: content && typeof content === 'object' && 'content' in content,
    sample: content !== undefined && content !== null ? JSON.stringify(content).substring(0, 200) : 'undefined/null'
  });
  return String(content);
}
